import { CustomListApi, WebApiCustomListsDtoCreateCustomListDto, WebApiCustomListsDtoCreateCustomListDtoFromJSON } from "../Repository/eventbookyapi";
import { GetApiConfiguration } from "./ServiceConfiguration";

export abstract class CustomListService {
    public static Get = async () => {
        return new CustomListApi(GetApiConfiguration()).apiCustomListGet();
    };

    public static CreateCustomList = async (newList: WebApiCustomListsDtoCreateCustomListDto) => {
        return new CustomListApi(GetApiConfiguration()).apiCustomListPost({ webApiCustomListsDtoCreateCustomListDto: WebApiCustomListsDtoCreateCustomListDtoFromJSON(newList) });
    };

    public static GetCustomLists = async () => {
        return new CustomListApi(GetApiConfiguration()).apiCustomListGet();
    };

    public static GenerateExcel = async (id: number) => {
        return new CustomListApi(GetApiConfiguration()).apiCustomListGenerateExcelGetRaw({ id });
    };

    public static DeleteCustomList = async (id: number) => {
        return new CustomListApi(GetApiConfiguration()).apiCustomListIdDelete({ id });
    };

    public static GetCustomList = async (id: number) => {
        return new CustomListApi(GetApiConfiguration()).apiCustomListIdGet({ id });
    };

    public static UpdateCustomList = async (id: number, updateDto: WebApiCustomListsDtoCreateCustomListDto) => {
        return new CustomListApi(GetApiConfiguration()).apiCustomListIdPut({
            id,
            webApiCustomListsDtoUpdateCustomListDto: updateDto
        });
    };

    public static GetCustomListHistory = async () => {
        return new CustomListApi(GetApiConfiguration()).apiCustomListCustomListHistoryGet();
    };
};

